module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('logo-loader', {
    attrs: {
      "isActive": _vm.logoLoaderActive
    }
  }), _vm._v(" "), (!_vm.$auth.ready()) ? [_vm._v("LOADING...")] : _vm._e(), _vm._v(" "), (_vm.isVerified) ? void 0 : _vm._e(), _vm._v(" "), (_vm.$auth.ready()) ? [(!_vm.$route.meta.skipStructure) ? [(_vm.newAppVersion) ? _c('div', {
    attrs: {
      "id": "new-version-message"
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_c('p', {
    staticClass: "title is-size-5"
  }, [_vm._v(_vm._s(_vm.$t('new_version_note')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('new_version_note1')))])]) : _vm._e(), _vm._v(" "), (_vm.User.info.ID && _vm.$getCookie('login_license_read').length == 0) ? _c('new-terms-modal', {
    attrs: {
      "user-id": _vm.User.info.ID
    }
  }) : _vm._e(), _vm._v(" "), _c('header', {
    class: _vm.$route.name
  }, [(_vm.User.info.client && _vm.User.info.client.verified !== 'yes' && !_vm.isRegistration && _vm.isLive && _vm.DocCount == 0) ? _c('div', {
    staticClass: "notification uploadDocuments is-primary",
    on: {
      "click": function($event) {
        return _vm.firstLogin(_vm.uploadDocumentsURL)
      }
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('upload_documents_notice'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headWrap"
  }, [_c('div', {
    staticClass: "logo",
    class: {
      'is-pulled-right logo-fa': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    },
    attrs: {
      "href": '/' + _vm.Language + '/'
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRegistration),
      expression: "!isRegistration"
    }],
    staticClass: "hamb icon is-large has-text-white is-hidden-desktop",
    class: {
      'is-pulled-right': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    },
    on: {
      "click": function($event) {
        _vm.sidenavHidden = !_vm.sidenavHidden
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-bars"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/' + _vm.Language + '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/eurotrader_logo_rgb_white.svg")
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-hidden-touch",
    class: {
      'float-right-only': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.parentHeading))]), _vm._v(" "), (!_vm.$auth.check()) ? _c('div', {
    staticClass: "action",
    class: {
      'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('router-link', {
    staticClass: "button is-primary main login is-pulled-right",
    attrs: {
      "to": '/' + _vm.Language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.$t('login').tUpper()))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isRegistration) ? _c('div', {
    staticClass: "action is-unselectable",
    class: {
      'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('div', {
    staticClass: "dropdown user",
    class: {
      'is-active': _vm.userHeadMenuActive, 'is-left ': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-right is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "user-dropdown"
    },
    on: {
      "click": function($event) {
        _vm.userHeadMenuActive = !_vm.userHeadMenuActive
      }
    }
  }, [_c('span', {
    staticClass: "welcome"
  }, [_c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v(_vm._s(_vm.$t('welcome').tTitle()) + ", " + _vm._s(_vm.displayName) + " |")]), _vm._v(" "), _c('span', {
    staticClass: "has-text-white has-text-weight-normal"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('wallet_balance').tTitle()) + "\n                        "), _c('b', [_vm._v(_vm._s(_vm.$formatMoney(Math.floor(_vm.User.wallet.balance * 100) / 100, _vm.currencySymbols[_vm.User.wallet.currency])))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu user",
    attrs: {
      "id": "user-dropdown",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "dropdown-item big"
  }, [_c('p', {
    staticClass: "is-hidden-desktop has-text-left",
    staticStyle: {
      "padding-top": "35px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('welcome').tTitle()) + ",\n                        "), _c('b', [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _c('p', {
    staticClass: "balance",
    class: {
      'is-pulled-right ': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('wallet_balance')) + "\n                        "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$formatMoney(Math.floor(_vm.User.wallet.balance * 100) / 100, _vm.currencySymbols[_vm.User.wallet.currency])))])])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item logout-dropdown-item",
    class: {
      'is-pulled-left ': _vm.Language == 'fa' || _vm.Language == 'ar', 'position-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [(_vm.$auth.check()) ? _c('div', {
    staticClass: "button is-fullwidth main is-primary",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('logout').tUpper()))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item profile_buttons"
  }, [_c('div', {
    staticClass: "button is-fullwidth is-primary",
    on: {
      "click": function($event) {
        return _vm.uddGoTo('/' + _vm.Language + '/finance/deposit')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('deposit').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "button is-fullwidth is-black",
    on: {
      "click": function($event) {
        return _vm.uddGoTo('/' + _vm.Language + '/finance/withdraw')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('withdraw').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "button is-fullwidth is-primary is-outlined",
    on: {
      "click": function($event) {
        return _vm.uddGoTo('/' + _vm.Language + '/finance/internal-transfer')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('internal_transfer').tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item lang-dropdown-item"
  }, [_c('div', {
    staticClass: "is-fullwidth is-right is-pulled-right"
  }, [_vm._v("\n                         \n                        "), _c('span', {
    staticClass: "select clean is-small"
  }, [_c('language')], 1)]), _vm._v(" "), (!_vm.$auth.check()) ? _c('router-link', {
    staticClass: "button is-primary is-fullwidth main login is-pulled-right",
    attrs: {
      "to": '/' + _vm.Language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.$t('login').tUpper()))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })], 1)])])])]) : _vm._e()])])] : _vm._e(), _vm._v(" "), _c('main', {
    class: {
      solo: _vm.$route.meta.skipStructure, register: _vm.isRegistration, noSideNav: _vm.sidenavHidden
    },
    attrs: {
      "section_name": _vm.$route.name
    }
  }, [(_vm.User.info.first_login === 'no' && _vm.$route.name !== 'Verify email | english') ? [_c('article', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-header"
  }, [(_vm.isIB) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_title_ib'))
    }
  }) : (_vm.isLive) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_title_live'))
    }
  }) : _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_title_demo'))
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.firstLogin()
      }
    }
  })]), _vm._v(" "), (_vm.isIB) ? _c('div', {
    staticClass: "message-body",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_text_ib', {
        contactURL: _vm.contactURL
      }))
    }
  }) : (_vm.isLive) ? _c('div', {
    staticClass: "message-body",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_text_live', {
        contactURL: _vm.contactURL
      }))
    }
  }) : _c('div', {
    staticClass: "message-body",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome_text_demo', {
        contactURL: _vm.contactURL,
        platformDownloadURL: _vm.downloadURL
      }))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.firstLogin()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('done').tUpper()))])])] : [(!_vm.$route.meta.skipStructure) ? [(!_vm.isRegistration) ? _c('section', {
    staticClass: "sidenav",
    class: {
      'is-hidden': _vm.sidenavHidden, 'float-right-only': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [(_vm.User.info.client && _vm.User.info.client.account_state) ? _c('div', {
    staticClass: "account-status",
    class: _vm.User.info.client.account_state
  }, [_c('div', {
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('account')) + " " + _vm._s(_vm.status[_vm.User.info.client.account_state] == 'Approved' ? _vm.$t('client_state_approved') : _vm.$t('client_state_pending')))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, _vm._l((_vm.Menu), function(item, index) {
    var _obj;

    return (!item.meta || item.meta.skipMenu !== true) ? _c('li', {
      key: index,
      class: {
        'is-active': item.meta.active
      }
    }, [_c('router-link', {
      class: {
        'is-active': item.meta.active
      },
      attrs: {
        "to": '/' + _vm.Language + (item.path || item.children[0].path)
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t(item.meta.T)) + "\n                    "), _c('i', {
      class: ( _obj = {
        'icon-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      }, _obj['icon ' + item.meta.icon] = true, _obj )
    })])], 1) : _vm._e()
  }), 0), _vm._v(" "), (_vm.isDemo) ? _c('div', {
    staticClass: "button centered is-primary"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/register/upgrade'
    }
  }, [_vm._v(_vm._s(_vm.$t('upgrade_to_live_account').tUpper()))])], 1) : _vm._e(), _vm._v(" "), (_vm.isLive && !_vm.isIB) ? [_c('div', {
    staticClass: "button centered is-primary",
    on: {
      "click": function($event) {
        _vm.becomeAnIBModalActive = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('become_a_partner').tUpper()))])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isLive && !_vm.isIB) ? _c('div', {
    staticClass: "modal small",
    class: {
      'is-active': _vm.becomeAnIBModalActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "target_region"
    }
  }, [_vm._v(_vm._s(_vm.$t('what_geographic_region')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ibMainTargetRegion),
      expression: "ibMainTargetRegion"
    }],
    staticClass: "is-fullwidth",
    attrs: {
      "name": "ib_main_target_region",
      "id": "target_region"
    },
    domProps: {
      "value": (_vm.ibMainTargetRegion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ibMainTargetRegion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.User.wallet.currency !== 'USD') ? _c('p', {
    staticClass: "convertPartnerCurrencyWarning"
  }, [_vm._v(_vm._s(_vm.$t('note_wallet_currency_conversion_partner')))]) : _vm._e()])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot right"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.becomeAnIBModalActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel').tUpper()))]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.updateToAnIB()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('become_a_partner').tUpper()))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isRegistration && !_vm.$route.meta.skipTopNav) ? _c('section', {
    staticClass: "topnav",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_vm._l((_vm.Menu), function(item, index) {
    return [(item.meta.active && item.children && item.children.length) ? [_vm._l((item.children), function(child) {
      return [(child.meta.skipMenu !== true && _vm.extraMenuItemChecksPassed(child) === true) ? _c('router-link', {
        key: index + '-' + child.path,
        staticClass: "nav-item",
        class: {
          'is-active': child.meta.navActive
        },
        attrs: {
          "to": '/' + _vm.Language + item.path + (child.path || '')
        }
      }, [(child.meta.Ticon) ? [_c('i', {
        class: 'icon ' + child.meta.Ticon
      })] : [_vm._v(_vm._s(_vm.$t(child.meta.T).tUpper()))]], 2) : _vm._e()]
    })] : _vm._e()]
  })], 2)])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": _vm.$route.meta.noContentPadding ? '' : 'content'
    }
  }, [(!_vm.$route.meta.skipStructure && !_vm.isRegistration && !_vm.$route.meta.skipHeading) ? _c('h2', {
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.heading))]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "platformImages": _vm.platformImages
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })]], 2), _vm._v(" "), (!_vm.$route.meta.skipFooter) ? [_c('footer', [_c('div', {
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "footerMain"
    }
  }, [_c('div', {
    attrs: {
      "id": "footerRow1"
    }
  }, [_c('div', {
    class: {
      'float-right-only': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "footerLogoContainer"
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footerRow2"
    }
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer_certificate_eurotrader', {
        link: 'https://financialcommission.org/eurotrader/'
      }))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "footerTitle"
  }, [_vm._v(_vm._s(_vm.$t("risk_warning")))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer_risk_warning', {
        brokerURL: this.websiteURL,
        urlRandomString: this.$randomString()
      }))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "contacts"
  }, [_c('h2', {
    staticStyle: {
      "font": "normal normal 650 12px/14px Roboto",
      "color": "#6826F4"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact').tUpper()))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("+44 (0)20 8004 7430")]), _vm._v(" "), _c('p', [_vm._v("support@eurotrader.com")]), _vm._v(" "), _c('br')])])])])])] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "profile-head-icon"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/icons/profile-head.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/eurotrader_logo_rgb_white.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc235ee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 807
// module chunks = 0